import { css, html, LitElement, nothing, unsafeCSS } from 'lit';
import styles from './toggle.scss?inline';
import { createRef, ref } from 'lit/directives/ref.js';
import { EVENTS } from './constants';
import { FormValidationController } from '../../controllers/FormValidationController';

export default class SotbitToggle extends LitElement {
    static formAssociated = true;

    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        name: { type: String },
        checked: { type: Boolean, reflect: true },
        disabled: { type: Boolean, reflect: true },
        required: { type: Boolean, reflect: true },
    };

    constructor() {
        super();

        this._internals = this.attachInternals();
        this.inputRef = createRef();
        this.checked = false;
        this.disabled = false;
        this.required = false;
        this._defaultChecked = this.checked;

        this._validationController = new FormValidationController(this, {
            getValue: () => (this.checked ? 'on' : ''),
            getInputRef: () => this.inputRef,
        });

        this.handleUpdateFormValue = this.updateFormValue.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    updateFormValue() {
        this._internals.setFormValue(this.checked ? 'on' : null, this.checked);
        this._validationController.validate();
        this.dispatchEvent(
            new CustomEvent(EVENTS.CHANGE, {
                detail: { checked: this.checked },
                bubbles: true,
                composed: true,
            })
        );
    }

    formAssociatedCallback() {
        this.updateFormValue();
    }

    formDisabledCallback(disabled) {
        this.disabled = disabled;
    }

    formResetCallback() {
        this.checked = this._defaultChecked;
        if (this.inputRef?.value) {
            this.inputRef.value.checked = this.checked;
        }

        this.updateFormValue();
    }

    formStateRestoreCallback(state) {
        this.checked = Boolean(state);
        if (this.inputRef?.value) {
            this.inputRef.value.checked = this.checked;
        }
    }

    _onChange(e) {
        this.checked = e.target.checked;
        this.updateFormValue();
    }

    render() {
        return html`
            <label class="toggle">
                <input
                    type="checkbox"
                    name="${this.name || nothing}"
                    ?checked=${this.checked}
                    ?disabled=${this.disabled}
                    ?required="${this.required}"
                    ${ref(this.inputRef)}
                    @change=${this._onChange}
                />
                <span class="toggle__track">
                    <span class="toggle__circle">
                        ${this.checked
                            ? html`<sotbit-icon icon="check" size="xs"></sotbit-icon>`
                            : html`<sotbit-icon icon="close" size="xs"></sotbit-icon>`}
                    </span>
                </span>
                <span class="toggle__label">
                    <slot></slot>
                </span>
            </label>
        `;
    }
}
